import React, { ReactElement } from "react";
import cx from "classnames";

//dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import type { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

// helpers
import { priceInRupee } from "@cart-ui/helpers/Price";
import { AriaHidden } from "@swiggy-private/core-ui";

// constants
import { CART_ITEMS_TEST_IDS } from "@swiggy-private/cart-test-ids";

import styles from "../styles/FoodItem.scss";

interface ItemPriceProps {
    className?: string;
    itemPrice: number;
    finalPrice: number;
    freeQuantity: number;
    isInputQtyField?: boolean;
    dontFormatPrice?: boolean;
    withoutMargin?: boolean;
    itemQuantity?: number;
    customPriceColor?: keyof IColors;
}

export const ItemPrice = React.memo(function ItemPrice(props: ItemPriceProps): ReactElement {
    const { itemPrice, finalPrice, freeQuantity, itemQuantity } = props;

    // When item is free due to B1G1, and quantity is 1, then dont show price which is 0 Rs
    const showPrice = !(finalPrice === 0 && freeQuantity === itemQuantity);

    const priceWrapperClass = cx(styles.priceContainer, styles.priceContainerCartV2, props.className);

    const priceContainerClass = cx(styles.priceContainerRupee, {
        [styles.priceContainerRupeeIncWidth]: props.isInputQtyField,
        [styles.foodItemPriceBigNoMargin]: props.withoutMargin,
    });

    const strikedPriceClass = cx(styles.priceContainerStrike, styles.priceContainerRupee, {
        [styles.foodItemPriceBigNoMargin]: props.withoutMargin,
    });

    const freeQuantityTextClass = cx(styles.priceContainerFreeItem, {
        [styles.foodItemPriceBigNoMargin]: props.withoutMargin,
    });

    return (
        <AriaHidden as="div" className={priceWrapperClass}>
            {itemPrice !== finalPrice && (
                <Text
                    variant="V2.caption.neutral.bold"
                    color="text_Med_Emphasis"
                    className={strikedPriceClass}
                    data-testid={CART_ITEMS_TEST_IDS.CART_ITEM_STRIKED_PRICE}
                >
                    {priceInRupee(itemPrice, props.dontFormatPrice)}
                </Text>
            )}
            {showPrice && (
                <Text
                    variant="V2.body2.neutral.regular"
                    color={props.customPriceColor || "text_High_Emphasis"}
                    className={priceContainerClass}
                    data-testid={CART_ITEMS_TEST_IDS.CART_ITEM_PRICE}
                >
                    {priceInRupee(finalPrice, props.dontFormatPrice)}
                </Text>
            )}
            {freeQuantity > 0 && (
                <Text
                    variant="V2.overline.neutral.medium"
                    color="positive"
                    className={freeQuantityTextClass}
                >{`${freeQuantity} FREE`}</Text>
            )}
        </AriaHidden>
    );
});
